import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../shared';
import KnowledgeHubLayout from '../explore/KnowledgeHubLayout';
import DiscoverySection from '../explore/DiscoverySection';
import OfficialCitation from '../explore/OfficialCitation';
import FaqAccordion from '../explore/FaqAccordion';
import CategoryGuidesSection from './CategoryGuidesSection';
import { LAST_VERIFIED } from '../../data/officialSources';
import { SHOPPING_HUB } from '../../data/knowledgeHubContent';
import '../../styles/explore.scss';

function ShoppingHubPage() {
	const hub = SHOPPING_HUB;

	return (
		<KnowledgeHubLayout
			seo={(
				<Seo
					title="Shopping in Nepal — Souvenirs, Crafts, Markets & Bargaining"
					path="/shopping"
					description="Complete guide to shopping in Nepal — pashmina, singing bowls, handmade paper, tea, thangka, trekking gear, best markets, bargaining tips, and export rules."
				/>
			)}
			hero={{ image: hub.hero, eyebrow: hub.eyebrow, title: hub.title, lead: 'What to buy, where to buy it, what to avoid, and how not to overpay — from Thamel souvenir stalls to Patan craft workshops.' }}
			quickFacts={hub.quickFacts}
			intro={{ title: 'Shop like an informed traveler', text: 'Nepal has extraordinary crafts and mediocre tourist traps — often in the same street.', body: 'The difference is knowing what you are buying, where it is actually made, and what a fair price looks like. This hub covers every major souvenir category, the best markets, bargaining etiquette, and what you can legally take home.' }}
			faqs={hub.faqs}
			related={hub.related}
			cta={{ title: 'Bought your souvenirs — explore where they come from', text: 'Patan metalwork, Bhaktapur pottery, and Ilam tea gardens are destinations worth visiting.', to: '/destinations', label: 'Explore Nepal' }}
		>
			<DiscoverySection eyebrow="What to buy" title="Souvenirs worth taking home">
				<div className="info-card-grid">
					{hub.categories.map((c) => (
						<div key={c.name} className="info-card">
							<div className="info-card__body">
								<h3 className="info-card__title">{c.name}</h3>
								<p className="info-card__text">{c.summary}</p>
								<p className="info-card__text"><strong>Where:</strong> {c.where}</p>
								<p className="info-card__text" style={{ fontStyle: 'italic' }}>{c.tip}</p>
							</div>
						</div>
					))}
				</div>
			</DiscoverySection>

			<DiscoverySection eyebrow="Where to shop" title="Markets & shopping districts" alt>
				<div className="info-card-grid">
					{hub.markets.map((m) => (
						<div key={m.name} className="info-card">
							<div className="info-card__body">
								<p className="info-card__label">{m.type}</p>
								<h3 className="info-card__title">{m.name}</h3>
								<p className="info-card__text">{m.desc}</p>
							</div>
						</div>
					))}
				</div>
			</DiscoverySection>

			<DiscoverySection eyebrow="Practical" title="Bargaining, export & customs">
				<div className="editorial-columns">
					<div>
						<h3 style={{ fontSize: '1.1rem', color: '#253f72' }}>Bargaining guide</h3>
						<p style={{ lineHeight: 1.7, color: '#3d4554' }}>{hub.bargaining}</p>
						<p className="section-source-tag section-source-tag--editorial">Editorial guidance — shopping etiquette is not government-regulated</p>
					</div>
					<div>
						<h3 style={{ fontSize: '1.1rem', color: '#253f72' }}>Export &amp; customs</h3>
						<p style={{ lineHeight: 1.7, color: '#3d4554' }}>{hub.exportRules}</p>
						<OfficialCitation
							sourceName={hub.exportSource.name}
							sourceUrl={hub.exportSource.url}
							lastVerified={LAST_VERIFIED}
							subjectToChange
						/>
					</div>
				</div>
			</DiscoverySection>
			<CategoryGuidesSection category="shopping" title="Shopping guides" alt />
		</KnowledgeHubLayout>
	);
}

export default ShoppingHubPage;
